import VirtualTourViewer from '../../components/VirtualTourViewer';

function ArtRoom({title = "The Art Room"}) {
  const layouts = [
    {
        id: 'layout01',
        image: '/tours/art-room-thumb03.avif',
        title: 'Banquet 128 guests',
        description: 'Round and long tables',
        source: 'https://3d.thepamarket.com/the-art-room-04-cocktail/',
        alt: 'Banquet layout'

        },
        {
        id: 'layout02',
        image: '/tours/art-room-thumb02.avif',
        title: 'Ceremony',
        description: '78 guests seated',
        source: 'https://3d.thepamarket.com/the-art-room-04-ceremony/',
        alt: 'Ceremony layout'
        },

        {
        id: 'layout03',
        image: '/tours/art-room-thumb01.avif',
        title: 'Vanilla Box',
        description: 'Empty space for your own setup',
        source: 'https://3d.thepamarket.com/the-art-room-03/',
        alt: 'Vanilla Box layout'
        }
  ];

  return (
    <VirtualTourViewer 
        layouts={layouts}
        title={title}
    />
  );
}

export default ArtRoom;